import React from "react";
import { Badge, IconButton } from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";

function NotificationTrigger({ unreadCount, onOpen }) {
  return (
    <Badge
      badgeContent={unreadCount}
      color="error"
      max={99}
      invisible={unreadCount === 0}
      className="notification-badge"
    >
      <IconButton
        aria-label="Open notifications"
        className="notification-trigger"
        onClick={onOpen}
      >
        <NotificationsNoneOutlinedIcon />
      </IconButton>
    </Badge>
  );
}

export default React.memo(NotificationTrigger);
